









































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Analysis } from "@/api/analyses/types";
import { EnvironmentalResponseDTO, EnvironmentalDTO } from "@/api/environmental/types";
import CarInfractionsModal from "../car-infractions-modal/CarInfractionsModal.vue";
import CarInfractionsTable from "../car-infractions-table/CarInfractionsTable.vue";
import Loading from "@/components/loading/Loading.vue";
import * as service from '@/services/environmental/index';
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

const initialPolygon = {
  type: "FeatureCollection",
  features: [],
} as GeoJSON.FeatureCollection;

@Component({
  name: "CarInfractions",
  components: {
    CarInfractionsModal,
    CarInfractionsTable,
    Loading,
    AgroIcons
  },
})
export default class CarInfractions extends Vue {

  private showModal: Boolean = false;
  private isShowingInMap: Boolean = false;
  private isLoading: Boolean = true;
  private justRequested: Boolean = false;
  private environmental: EnvironmentalDTO = new EnvironmentalDTO();
  private downloading: Boolean = false;
  private polygon: GeoJSON.FeatureCollection = initialPolygon;
  private mapLegend: any = {};
  private polling: any;
  
  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: Number, required: true })
  private year!: number;

  private async mounted() {
    await this.load();
    this.isLoading = false;
    this.trackResult(true);
  }

  private trackResult(start = false) {
    if ((this.environmental.isProcessing || this.environmental.notCreated) && (start || this.polling != null)) {
      this.polling = setTimeout(async () => {
        await this.load();
        this.trackResult();
      }, 5000);
    }
  }

  private beforeDestroy() {
    if (this.polling) {
      clearTimeout(this.polling);
      this.polling = null;
    }
  }

  @Emit("showInMap")
  private async showInMap() {
    this.isShowingInMap = true;
    if (this.polygon === initialPolygon) {
      this.downloading = true;
      this.polygon = await service.downloadGeoJson(this.environmental!.geojsonIntersectUrl);
      this.downloading = false;
    }
    this.mapLegend = this.polygon.features
      .map(it => { 
        const label = it.properties!!['crop_area'] > 0 ? 'INFRACTION': it.properties!!['type'];
        return {
          'label': this.$t('environmental.infractions-type.' + label),
          'color': it.properties!!['fill']
        }
      })
      .filter((v, i, a)=> a.findIndex(t=>(JSON.stringify(t) === JSON.stringify(v)) )=== i);
      this.mapLegend.unshift({'label': this.$t('environmental.car-infractions.map-legend')})
    return { polygon: this.polygon, legend: this.mapLegend} ;
  }

  @Emit("removeFromMap")
  private async removeFromMap() {
    this.isShowingInMap = false;
  }

  private async downloadGeojson() {
    this.downloading = true;
    const polygon = await service.downloadGeoJson(this.environmental!.geojsonIntersectUrl);

    if (!!polygon) {
      const blob = new Blob([JSON.stringify(polygon)], { type: 'application/geo+json; encoding=utf8' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = this.analysis.farmName + '_infractions.geojson';
      link.href = url;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
    this.downloading = false;
  }

  private async downloadImage() {
    this.downloading = true;
 
    const link = document.createElement('a');
    link.download = this.analysis.farmName + '_infractions.png';
    link.href = this.environmental!.imageIntersectUrl;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    this.downloading = false;
  }

  private async load() {
    this.environmental = await service.find(this.analysis.uuid, this.year);
  }

  private async receiveResponse() {
    this.justRequested = true;
    this.isLoading = true;
    this.hideModal();
    await this.load();
    this.isLoading = false;
    this.trackResult(true);
  }

  private hideModal() {
    this.showModal = false;
  }

  get allYears() {
    return this.analysis.farmAnalyses.map(it => it.analysisYear);
  }

  get isDownloading() {
    return this.downloading;
  }

  private showLoading() {
    return this.isLoading || this.environmental.isProcessing;
  }

  private showGenerate() {
    return !this.isLoading && !this.justRequested && this.environmental.notCreated ;
  }

  private showDataSection() {
    return !this.environmental.isProcessing && !this.environmental.notCreated;
  }

  private hasInfractions() {
    return this.showDataSection() && this.environmental.hasInfractions;
  }

  private get hasData() {
    return this.environmental.isFinished && !!this.environmental.geojsonIntersectUrl;
  }
}
